import React from "react";
import { Field } from "formik";
import ExpandButton from "forms/components/ExpandButton";
import FormContainer from "forms/components/FormContainer";
import { TextareaField } from "forms/fields";
import PropTypes from "prop-types";

import { Translate } from "utils";

const { t } = new Translate("DealForm");

const Description = ({ formik: { setFieldValue, values }, isCompanyPage }) => {
  const { _descriptionExpanded: isExpanded } = values;
  const onExpand = () => setFieldValue("_descriptionExpanded", true, false);

  return isExpanded ? (
    <FormContainer title={t("description.title")}>
      <Field
        component={TextareaField}
        name="description"
        placeholder={t("description.placeholder")}
        rows={isCompanyPage ? 5 : 2}
        inset
      />
    </FormContainer>
  ) : (
    <ExpandButton label={t("description.disclose")} onExpand={onExpand} />
  );
};

Description.propTypes = {
  formik: PropTypes.shape({
    setFieldValue: PropTypes.func,
    values: PropTypes.object,
  }),
  isCompanyPage: PropTypes.bool,
};

export default Description;
